module.exports = __webpack_public_path__ + "static/video-2-543fb0986e491433fd3ed9ffbe850f81.mp4";